/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_Feature_Free_ModelsInputs */



/**
* | output |
* | --- |
* | "{count} AI models, incl. EU-hosted" |
*
* @param {Plan_Feature_Free_ModelsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_feature_free_models = /** @type {((inputs: Plan_Feature_Free_ModelsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Feature_Free_ModelsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} KI-Modelle, inkl. EU-gehostet`)
	return /** @type {LocalizedString} */ (`${i?.count} AI models, incl. EU-hosted`)
});